import { CompactLogoIcon2023 } from '../svgs/icons/CompactLogoIcon2023';

export const LoadingLogo = ({ size }: { size: number }) => {
	return <CompactLogoIcon2023 width={size} height={size} loading />;
};
